export default function PHP_SimpleXMLParser() {
  return (
    <div>
      <h1>PHP_SimpleXMLParser</h1>
    </div>
  );
}
